module.exports = __webpack_public_path__ + "static/img/img4.cbee72e2.png";